<template>
  <div class="scale-controller-component" ref="scaleController">
    <button
      @click="setBoardScale(currentScale - step)"
      class="scale-btn"
      :class="{ 'is-disabled': currentScale <= 100 }"
      :disabled="currentScale <= 100"
      tabindex="0"
      aria-label="缩小"
    >
      <el-tooltip
        popper-class="live-room-tooltip"
        effect="dark"
        content="缩小"
        placement="top"
        :disabled="isHXApp"
      >
        <img src="../../assets/images/search-zoom-out.png" />
      </el-tooltip>
    </button>
    <p
      :class="['current-scale', { 'is-active': isDropdownVisible }]"
      @click="handleCurrentScaleClick"
      tabindex="0"
      aria-label="当前缩放比例"
    >
      <span>{{ currentScale }}% </span>
      <i class="el-icon-arrow-down"></i>
    </p>
    <button
      @click="setBoardScale(currentScale + step)"
      class="scale-btn"
      :class="{ 'is-disabled': currentScale >= 1600 }"
      :disabled="currentScale >= 1600"
      tabindex="0"
      aria-label="放大"
    >
      <el-tooltip
        popper-class="live-room-tooltip"
        effect="dark"
        content="放大"
        placement="top"
        :disabled="isHXApp"
      >
        <img src="../../assets/images/search-zoom-in.png" />
      </el-tooltip>
    </button>
    <transition name="el-zoom-in-bottom">
      <div class="scale-dropdown" v-show="isDropdownVisible">
        <ul>
          <li
            v-for="scale in scales"
            :key="scale"
            @click="handleScaleSelect(scale)"
            :class="{ 'is-current': scale === currentScale }"
            :tabindex="scale === currentScale ? -1 : 0"
            :aria-disabled="scale === currentScale"
          >
            {{ scale }}%
            <span v-if="scale === currentScale">(当前)</span>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      currentScale: 100,
      isDropdownVisible: false,
      step: 10,
      isProcessing: false, // 新增处理锁-桌面端-多次点击放大缩小-应用会卡死（同步事件未处理完，导致页面后续点击事件不执行了）
    };
  },
  mounted() {
    document.removeEventListener("click", this.handleClickOutside);
    document.addEventListener("click", this.handleClickOutside);
  },
  watch: {
    "$store.state.whiteBoard.currentFileInfo": {
      immediate: true, // 组件创建时立即触发
      handler(newValue) {
        if (newValue) {
          this.currentScale = this.whiteBoardService.getBoardScale();
        }
      },
    },
  },
  beforeDestroy() {},
  methods: {
    setBoardScale(boardScale) {
      if (boardScale > 1600 || boardScale < 100) return;
      if (this.isProcessing) return; // 正在处理时直接返回
      this.currentScale = boardScale;
      // 清除上一次的定时器
      if (this.boardScaleDebounceTimer) {
        clearTimeout(this.boardScaleDebounceTimer);
      }
      // 启动新的定时器，500ms后执行
      this.boardScaleDebounceTimer = setTimeout(() => {
        this.isProcessing = true; // 开始处理
        setTimeout(() => {
          this.whiteBoardService.setBoardScale(this.currentScale);
          this.currentScale = this.whiteBoardService.getBoardScale();
          this.boardScaleDebounceTimer = null;
          this.isProcessing = false; // 处理完毕，允许后续点击
          console.log("====zy==boardScale执行了完了", this.currentScale);
        }, 0);
      }, 500);
    },
    handleCurrentScaleClick() {
      this.isDropdownVisible = !this.isDropdownVisible;
    },
    handleScaleSelect(scale) {
      if (scale !== this.currentScale) {
        this.setBoardScale(scale);
      }
      this.isDropdownVisible = false;
    },
    handleClickOutside(event) {
      if (
        this.$refs.scaleController &&
        !this.$refs.scaleController.contains(event.target)
      ) {
        this.isDropdownVisible = false;
      }
    },
  },
  computed: {
    ...mapState("live", ["whiteBoardService", "isHXApp"]),
    scales() {
      const baseScales = [100, 150, 200];
      const allScales = [...baseScales, this.currentScale];
      return [...new Set(allScales)].sort((a, b) => a - b);
    },
  },
};
</script>

<style lang="scss" scoped>
.scale-controller-component {
  height: 38px;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(20, 20, 43, 0.04);
  border-radius: 10px 10px 10px 10px;
  border: 1px solid $live-room-border-color;
  display: flex;
  align-items: center;
  padding: 0 8px;
  .scale-btn {
    display: flex;
    cursor: pointer;
    img {
      width: 20px;
      height: 20px;
    }
    &.is-disabled {
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: auto;
    }
  }
  .current-scale {
    display: flex;
    align-items: center;
    margin: 0 8px;
    font-weight: 500;
    font-size: 14px;
    color: #1d2129;
    line-height: 1;
    cursor: pointer;
    i {
      font-size: 14px;
      font-weight: bold;
      color: #1d2129;
      margin-left: 8px;
      transition: transform 0.3s ease;
    }
    &.is-active i {
      transform: rotate(180deg);
    }
  }
  .scale-dropdown {
    position: absolute;
    bottom: 45px;
    right: 0;
    z-index: 10;
    width: 109px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(20, 20, 43, 0.04);
    border-radius: 10px 10px 10px 10px;
    border: 1px solid $live-room-border-color;
    padding: 6px 0;
    ul {
      li {
        padding: 6px 0 6px 16px;
        cursor: pointer;
        white-space: nowrap;
        font-weight: 500;
        font-size: 14px;
        color: #11181c;

        &.is-current {
          color: #c9cdd4;
        }
        &:hover {
          background: $live-room-hover-bg;
        }
      }
    }
  }
}
</style>
